import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewCardShell, { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';
import { OVERVIEW_DUMMY_FIELDS } from './overviewDummyFields';

const IntelligenceInsightsCard = ({ model }) => {
    const navigate = useNavigate();
    const { intelligence } = model;

    if (!intelligence.ready) {
        return (
            <OverviewCardShell
                title="Intelligence Insights"
                compact
                footer={
                    <OverviewTextAction onClick={() => navigate('/lens-intelligence/insights')}>
                        Open Intelligence Insights →
                    </OverviewTextAction>
                }>
                <p className={styles.cardDescription}>Not ready — more project evidence required.</p>
            </OverviewCardShell>
        );
    }

    return (
        <OverviewCardShell
            title="Intelligence Insights"
            compact
            headerAside={
                intelligence.needsReview ? (
                    <span className={styles.badgeWarning} title={OVERVIEW_DUMMY_FIELDS.intelligenceNeedsReviewBadge}>
                        Needs review
                    </span>
                ) : null
            }
            footer={
                <OverviewTextAction onClick={() => navigate('/lens-intelligence/insights')}>
                    {intelligence.actionLabel ||
                        (intelligence.needsReview ? 'Review insights →' : 'Open Intelligence Insights →')}
                </OverviewTextAction>
            }>
            <p className={intelligence.subline === 'Up to date' ? styles.cardMetricMd : styles.cardStatus}>{intelligence.headline}</p>
            {intelligence.subline ? <p className={styles.cardDescription}>{intelligence.subline}</p> : null}
            {intelligence.meta ? <p className={styles.cardMutedSmall}>{intelligence.meta}</p> : null}
        </OverviewCardShell>
    );
};

export default IntelligenceInsightsCard;
